angular.module('invoice')
    .controller('InvoicePassController', function ($scope, $rootScope, $uibModalInstance, data, Invoice, InvoiceConst, InvoiceWorkerAbsence, User, InvoiceWorkflow) {
        this.$onInit = () => {
            this.workflowConfigurationLoaded = false
            this.workerAbsenceSelection = InvoiceWorkerAbsence.selection()
            this.item = data
            this.form = {
                id: this.item.id
            }
            this.onStatusChanged(this.item.status)
            InvoiceWorkflow.availableStatuses(this.item.status).then(statuses => this.statuses = statuses)
            InvoiceWorkflow.load().then(configuration => {
                this.commentRequiredBeforeStatuses = configuration.commentRequiredBeforeStatuses || []
                this.workflowConfigurationLoaded = true
            })
        }
        this.onStatusChanged = (newStatus) => {
            this.form.status = newStatus
            delete this.statusSettings
            delete this.form.worker
            this.workerAbsenceSelection.clear()
            if(this.isStatusTerminal()){
                this.users = []
            }
            Invoice.statusSettings({status: this.form.status}).$promise
                .then(item => {
                    this.statusSettings = item.users ? item : null
                })
                .finally(() => this.refreshUsers())
        }
        this.refreshUsers = q => {
            return User.autocomplete({q: q}).$promise.then((items) => {
                this.users = items.filter(item => this.statusSettings == null || this.statusSettings.users.map(u => u.id).indexOf(item.id) !== -1)
            })
        }
        this.onSelectionChanged = worker => {
            this.form.worker = worker
            if (!worker || worker.id == null) {
                this.workerAbsenceSelection.clear()
                return
            }
            return this.workerAbsenceSelection.load([worker])
        }
        this.isStatusTerminal = () => {
            return InvoiceWorkflow.isTerminal(this.form.status)
        }
        this.isCommentRequired = () => {
            return this.form.status !== this.item.status
                && (this.commentRequiredBeforeStatuses || []).includes(this.form.status)
        }
        this.isRequiredCommentMissing = () => {
            return this.isCommentRequired()
                && (!this.form.comment || this.form.comment.trim().length === 0)
        }
        this.canPassToSelectedWorker = () => this.workerAbsenceSelection.canProceed([this.form.worker])
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            if (!this.workflowConfigurationLoaded || this.isRequiredCommentMissing()) {
                return
            }
            return this.workerAbsenceSelection.validate([this.form.worker]).then(canProceed => {
                if (canProceed) {
                    return Invoice.pass(this.form).$promise.then(() => {
                        $uibModalInstance.close()
                        $rootScope.$broadcast(InvoiceConst.eventUpdate)
                    })
                }
            })
        }
    })
